function initSlider(root) {
  const frame = root.querySelector('[data-raw-slider-frame]');
  const input = root.querySelector('[data-raw-slider-input]');
  if (!frame || !input) return;

  const sync = () => frame.style.setProperty('--compare', input.value);

  input.addEventListener('input', sync);
  sync();
}

function initAccordion(root) {
  const items = Array.from(root.querySelectorAll('.raw-content-accordion__item'));

  items.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      items.forEach((other) => {
        if (other !== item) other.open = false;
      });
    });
  });
}

function initStepCarousel(root) {
  const track = root.querySelector('[data-raw-step-track]');
  const slides = Array.from(root.querySelectorAll('[data-raw-step-slide]'));
  const prevButton = root.querySelector('[data-raw-step-prev]');
  const nextButton = root.querySelector('[data-raw-step-next]');
  const dots = Array.from(root.querySelectorAll('[data-raw-step-dot]'));
  if (!track || slides.length === 0) return;

  function activeIndex() {
    const trackRect = track.getBoundingClientRect();
    let closest = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - trackRect.left);
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = index;
      }
    });

    return closest;
  }

  function updateDots() {
    const index = activeIndex();
    dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
  }

  function goTo(index) {
    const clamped = Math.max(0, Math.min(index, slides.length - 1));
    slides[clamped].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  }

  prevButton?.addEventListener('click', () => goTo(activeIndex() - 1));
  nextButton?.addEventListener('click', () => goTo(activeIndex() + 1));

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => goTo(index));
  });

  let scrollTimeout;
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateDots, 100);
  });

  updateDots();
}

document.querySelectorAll('[data-raw-content-slider]').forEach(initSlider);
document.querySelectorAll('[data-raw-content-root]').forEach(initAccordion);
document.querySelectorAll('[data-raw-step-carousel]').forEach(initStepCarousel);
